/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/GoogleAnalyticsAmd',[
    'jquery',
    './Logger'
], function ($, Logger) {
    //Check if that can be removed

    var cfg = window.RocConfig;
    var gaName = 'ga';
    var gaDebug = cfg.google.IsGADebug;

    // Setup temporary Google Analytics objects.
    window.GoogleAnalyticsObject = gaName;
    window[gaName] = function () {
        (window[gaName].q = window[gaName].q || []).push(arguments);
    };
    window[gaName].l = 1 * new Date();

    function createTracker(trackingId) {
        if (gaDebug) {
            // verbose logging when using analytics_debug.js lower in the file
            window.ga_debug = { trace: true };
        }

        // Immediately add a pageview event to the queue.
        window[gaName]('create', trackingId, 'auto');
        window[gaName]('send', 'pageview');
    };

    $(function () {
        // Retrieve TrackingId from config and the create tracker
        if (cfg.google && cfg.google.enableAnalyticsTracking && cfg.google.analyticsTrackingId) {
            createTracker(cfg.google.analyticsTrackingId);
        }
    });


    /**
     * Create a function that wraps `window[gaName]`.
     * This allows dependant modules to use `window[gaName]` without knowingly
     * programming against a global object.
     */
    var module = function () {
        window[gaName].apply(this, arguments);
    };

    /**
     * Asynchronously load Google Analytics, letting it take over our `window[gaName]`
     * object after it loads. This allows us to add events to `window[gaName]` even
     * before the library has fully loaded.
     */
    if (gaDebug && cfg.google && cfg.google.enableAnalyticsTracking && cfg.google.analyticsTrackingId) {
        // Use debug version of GA if debugging is enabled
        require(['//www.google-analytics.com/analytics_debug.js']);
    } else if (cfg.google && cfg.google.enableAnalyticsTracking && cfg.google.analyticsTrackingId) {
        require(['//www.google-analytics.com/analytics.js']);
    }
   

    return module;
});
